const POST_FIELDS = `
  _id,
  title,
  "slug": slug.current,
  publishedAt,
  readingTime{
    value,
    unit
  },
  mainImage{
    asset->{url}
  },
  author->{
    _id,
    name,
    image{
      asset->{url}
    }
  },
  category->{
    _id,
    title,
    "slug": slug.current
  },
  shortDescription,
  excerpt,
  body,
  seo{
    title,
    description,
    keywords,
    image{
      asset->{url}
    }
  }
`;

const POST_FIELDS_WITHOUT_BODY = `
  _id,
  title,
  "slug": slug.current,
  publishedAt,
  readingTime{
    value,
    unit
  },
  mainImage{
    asset->{url}
  },
  author->{
    _id,
    name,
    image{
      asset->{url}
    }
  },
  category->{
    _id,
    title,
    "slug": slug.current
  },
  shortDescription,
  excerpt,
  seo{
    title,
    description,
    keywords,
    image{
      asset->{url}
    }
  }
`;

export const ALL_BLOG_POSTS_QUERY = `
*[_type == "post"] | order(publishedAt desc) {
${POST_FIELDS}
}
`;

export const ALL_CATEGORIES_QUERY = `
*[_type == "category"] | order(title asc) {
  _id,
  title,
  "slug": slug.current,
  description,
  image{
    asset->{url}
  }
}
`;

export const BLOG_POST_BY_SLUG_QUERY = `
*[_type == "post" && slug.current == $slug][0]{
${POST_FIELDS}
}
`;

export const BLOG_POSTS_BY_CATEGORY_QUERY = `
*[_type == "post" && category->slug.current == $slug] | order(publishedAt desc) {
${POST_FIELDS}
}
`;

export const SEARCH_POSTS_QUERY = `
*[_type == "post" && title match $q] | order(publishedAt desc) {
${POST_FIELDS_WITHOUT_BODY}
}
`;
